
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { throwError as observableThrowError } from 'rxjs';
import { Observable } from 'rxjs/Rx';

import { API_BASE_KEY } from 'app/config';
import { AuthenticationService } from 'app/core/authentication/authentication.service';

const urls = [];

export function addAuthenticationUrl(url) {
  if (urls.indexOf(url) === -1) {
    urls.push(url);
  }
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  validarUrl(url) {
    return urls.some((urlPermitida: string | RegExp) => {
      if (urlPermitida instanceof RegExp) {
        return urlPermitida.test(url);
      }
      return url === urlPermitida;
    });
  }

  isAuthRequired(request: HttpRequest<any>): boolean {
    const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    // If utilizado para mandar o authenticationjwt para o serviço feito em python
    // Não precisa mais ser utilizado pois já foi corrigido no arquivo contratante.service.ts
    if(request.url.includes('matricula-api') || request.url.includes('matricula-api')) return true;
    /**
     * TODO - DESCOMENTAR EM CASO DE PRODUÇÃO
     */
    if (!urlRegex.test(request.url)) {
      return false;
    }
    
    return this.validarUrl(request.url);
  }

  isMoodleRest(url){
    if(url.indexOf("https://redacaodigital.grupoceuma.com.br") != -1)
      return true;
    return false;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authorization = API_BASE_KEY;
    const token = this.authenticationService.getAcessToken();
    const loggedUser = this.authenticationService.getLoggedUser();
    /*
      Author - Thiago e Lucas
        Foi preciso criar um if para recuperação de senha, pois o serviço de recuperação do vestibular
      usa AuthorizationJWT e o authentication usa Authorization com o token JWT. 
    */
    if(request.url.includes("crm-ceuma-api")){
      return next.handle(request);
    }


    if(loggedUser!=null&&(loggedUser.tipoLogin==='CONTRATANTE' 
       &&request.url==="https://www.extranet.ceuma.br/authentication-api/alterarSenha")
    ){
      authorization=token;
    }
    let setHeaders={}
    if(!this.isMoodleRest(request.url)){
      setHeaders = {
        Authorization: authorization,
        ...token && this.isAuthRequired(request) && { AuthorizationJWT: token },
      };
    }else{
      setHeaders={}
    }
    request = request.clone({ setHeaders });
    return next.handle(request)
      .catch((httpError: HttpErrorResponse) => {
        if (httpError.status === 401 && this.authenticationService.getLoggedUser()) {
          this.authenticationService.removeLoggedUser();
          this.router.navigate(['/restrito/login']);
        }
        return observableThrowError(httpError);
      });
  }
}
